import { type Dir, isOpposite } from '../engine';

export interface DirQueue {
  readonly items: readonly Dir[];
  readonly tail: Dir;
}

export function createQueue(current: Dir): DirQueue {
  return { items: [], tail: current };
}

/** 파이프라인 말단 기준으로 역방향·동일방향을 폐기한다. 포화 시 신규 입력을 버린다. */
export function pushDir(q: DirQueue, d: Dir, max: number): DirQueue {
  if (d === q.tail || isOpposite(q.tail, d)) return q;
  if (q.items.length >= max) return q;
  return { items: [...q.items, d], tail: d };
}

/** 틱당 1개 소비. 큐가 비면 null. */
export function popDir(q: DirQueue): { dir: Dir | null; queue: DirQueue } {
  if (q.items.length === 0) return { dir: null, queue: q };
  const [head, ...rest] = q.items;
  return { dir: head as Dir, queue: { items: rest, tail: q.tail } };
}
